import i18n from '@/i18n'
import { utcToLocalDate } from '@/utils/DateFormatter.js'
import { generateSvgForPdf, angelLogo } from '@/images/AngelSvgLibrary'
import { theme } from '@/plugins/theme'

export function getFooter (currentPage, includeAngelLogo, margin = getMargin({ left: 30, top: 0, right: 30, bottom: 0 }), textTopMargin = 6, pageCount = undefined, legendColumns = []) {
  return {
    margin,
    columns: [
      {
        svg: includeAngelLogo ? generateSvgForPdf(angelLogo, theme.primary) : blankSvg,
        width: 16
      },

      ...legendColumns,

      {
        text: i18n.t('printedOnDate', { date: utcToLocalDate(Date.now(), 'L - LT') }),
        alignment: 'center',
        margin: getMargin({ left: 0, top: textTopMargin, right: 0, bottom: 0 })
      },

      {
        text: pageCount ? i18n.t('pageOfPages', { page: currentPage, pages: pageCount }) : currentPage.toString(),
        width: pageCount ? 'auto' : 16,
        margin: getMargin({ left: 0, top: textTopMargin, right: 0, bottom: 0 })
      }
    ]
  }
}

export function getMargin ({ left = 0, top = 0, right = 0, bottom = 0 } = {}) {
  return [left, top, right, bottom]
}

export function activityPeriodRange ({ start, end }) {
  return end ? `${start} - ${end}` : start
}

export const alternatingRowColorsLayout = {
  fillColor: (rowIndex) => ((rowIndex + 1) % 2 === 0) ? '#EEEEEE' : null
}

const blankSvg = '<svg></svg>'
